module.exports = __webpack_public_path__ + "img/GOTV.30452d35.svg";